module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-06.5892b27e.svg";